import { GameFont } from '../../../../shared/scripts/GameFont.ts';
import { UIGameToolTipView } from '../../../../shared/scripts/ui_game/ui_game_tooltip/UIGameToolTipView.ts';
export class UIMGameToolTipView extends UIGameToolTipView {
    setConstants() {
        this.titleFont = GameFont.Size.Normal;
        this.bodyFont = GameFont.Size.Small;
        this.maxTipWidth = this.itemSize * 3.33;
        this.horizontalPadding = this.itemSize * 0.2;
        this.titleTopPadding = this.itemSize * 0.133;
        this.titleBottomPadding = this.itemSize * 0.07;
        this.bodyTopPadding = this.itemSize * 0.133;
        this.bodyLineHeight = this.itemSize * 0.36;
    }
}
